module.exports = __webpack_public_path__ + "static/img/home_case_bg2_zh_h5.8cd2ff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_case_bg2_zh_h5.png
// module id = WwLR
// module chunks = 34